module.exports = __webpack_public_path__ + "20f22b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_tag/Column/ic_left.png
// module id = 1250
// module chunks = 2